import {Checkbox, Table} from "semantic-ui-react";
import React from "react";

export function ExportCreditNotesPreview(props) {
    const {data, handleCheck} = props
    const creditnotes = data.creditnotes

    const listCreditNotes = Array.from(creditnotes.values()).map((creditnote) =>
        <Table.Row key={creditnote.id}>
            <Table.Cell><Checkbox key={creditnote.id} name={creditnote.id.toString()}
                                  onChange={() => handleCheck(creditnote.id)}
                                  checked={creditnote.checked}/></Table.Cell>
            <Table.Cell>{creditnote.id}</Table.Cell>
            <Table.Cell>{creditnote.creditnote_number}</Table.Cell>
            <Table.Cell>{creditnote.date}</Table.Cell>
            <Table.Cell>{creditnote.customer_name}</Table.Cell>
            <Table.Cell>{creditnote.exported_to_steuerberater}</Table.Cell>
        </Table.Row>
    );

    return (
        <Table celled striped>
            <Table.Header>
                <Table.Row>
                    <Table.HeaderCell>Auswahl</Table.HeaderCell>
                    <Table.HeaderCell>ID</Table.HeaderCell>
                    <Table.HeaderCell>NR</Table.HeaderCell>
                    <Table.HeaderCell>Gutschriftsdatum</Table.HeaderCell>
                    <Table.HeaderCell>Kunde</Table.HeaderCell>
                    <Table.HeaderCell>Exportdatum</Table.HeaderCell>
                </Table.Row>
            </Table.Header>
            <Table.Body>{listCreditNotes}</Table.Body>
        </Table>
    )
}